import { compareItems, rankItem } from "@tanstack/match-sorter-utils";
import {
  ColumnDef,
  FilterFn,
  SortingFn,
  sortingFns,
} from "@tanstack/react-table";

export const fuzzyFilter: FilterFn<any> = (row, columnId, value, addMeta) => {
  // Rank the item
  const itemRank = rankItem(row.getValue(columnId), value);

  // Store the itemRank info
  addMeta({ itemRank });

  // Return if the item should be filtered in/out
  return itemRank.passed;
};

export const fuzzySort: SortingFn<any> = (rowA, rowB, columnId) => {
  let dir = 0;
  // Only sort by rank if the column has ranking information
  if (rowA.columnFiltersMeta[columnId]) {
    dir = compareItems(
      (rowA.columnFiltersMeta[columnId] as any)?.itemRank as any,
      (rowB.columnFiltersMeta[columnId] as any)?.itemRank
    );
  }

  // Provide an alphanumeric fallback for when the item ranks are equal
  return dir === 0 ? sortingFns.alphanumeric(rowA, rowB, columnId) : dir;
};

export function getDefaultHiddenColumns(columns: ColumnDef<any, any>[]) {
  const hiddenColumns = columns.filter((col) => col.meta?.alwaysHide);

  const map = {} as Record<string, boolean>;
  for (const col of hiddenColumns) {
    if (!col.id) {
      console.warn("Column is missing id and will not be hidden", col);
      break;
    }
    map[col.id ?? ""] = false;
  }
  return map;
}
